import { Typography, IconButton, Popper, Grid } from '@mui/material';
import ShoppingCartCheckoutOutlinedIcon from '@mui/icons-material/ShoppingCartCheckoutOutlined';
import Text from './Text';
import { style } from 'constant/constants';
import { useState } from 'react';
import PropTypes from 'prop-types';
import FenceCartContent from './FenceCartContent';

const CalculatorCart = ({ disabled, cartData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleToggleOpen = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const emptyCartMessage = <Typography variant="body2">Your cart is empty.</Typography>;

  let cartItemsContent = null;
  if (cartData?.outputs?.length > 0 && !disabled) {
    cartItemsContent = <FenceCartContent cartData={cartData} />;
  }

  return (
    <div>
      <IconButton sx={{ mt: '2.3vh', borderRadius: 8 }} color="white" onClick={handleToggleOpen}>
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <Text sx={{ color: style.LIGHT.primary }}>View Cart</Text>
          </Grid>
          <Grid item>
            <ShoppingCartCheckoutOutlinedIcon style={{ color: style.LIGHT.primary }} />
          </Grid>
        </Grid>
      </IconButton>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        sx={{
          backgroundColor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0px 4px 8px rgb(0 0 0 / 0.1)',
          p: '0.75rem',
          opacity: 1,
          my: '0.25rem',
          width: 950
        }}>
        {!cartItemsContent && <div>{emptyCartMessage}</div>}
        {cartItemsContent}
      </Popper>
    </div>
  );
};

CalculatorCart.propTypes = {
  cartData: PropTypes.object,
  disabled: PropTypes.bool
};

export default CalculatorCart;
